import React from 'react';
import {Box, Typography} from '@mui/material';


export const Legend = () => {
    const legendItems = [
        {status: 'Slobodno', color: '#ced4da'},
        {status: 'Izabrano', color: '#3366FF'},
        {status: 'Rezervisano', color: '#ffa833'},
        {status: 'Zauzeto', color: '#ff1313'},
        {status: 'Nedostupno', color: '#6c757d'},
    ];
    return (
        <Box sx={{display: 'flex', justifyContent: 'center', gap: 2, my: 2, flexWrap: 'wrap'}}>
            {legendItems.map(item => (
                <Box key={item.status} sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Box sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '15px',
                        backgroundColor: item.color,
                        border: '1px solid',
                        borderColor: item.color
                    }}
                    />
                    <Typography variant="body2">{item.status}</Typography>
                </Box>
            ))}
        </Box>
    );
};
